import { useTranslator } from '@bluebeam/react-i18n';
import Tippy from '@tippyjs/react/headless';
import Button from 'components/Button';
import OptionsMeatball from 'components/Icons/OptionsMeatball';
import React, { useState } from 'react';

type EditLayerDropdownProps = {
  onDeleteClick: () => void;
  onEditClick: () => void;
};

const EditLayerDropdown: React.FC<EditLayerDropdownProps> = ({
  onDeleteClick,
  onEditClick,
}) => {
  const [clicked, setClicked] = useState<number>(0);
  const { translate } = useTranslator(['mapView']);

  const content = (attrs: any) => (
    <>
      <div
        {...attrs}
        className="column bgd-white-2 b-3 mr5 ws7 font-size-4 center"
        style={{
          boxShadow: '0 2px 16px 0 rgba(0, 116, 204, 0.08)',
        }}
      >
        <div className="bb-3 hrem-2p75 pt1">
          <Button
            onClick={() => {
              onEditClick();
              setClicked(0);
            }}
            style={{
              background: 'none',
              color: '#00579c',
              fontSize: '14px',
              outline: 'none',
            }}
            variant="tertiary"
            id="map-edit-layer-btn"
          >
            {translate('mapView:editLayerDropdown.editLayer')}
          </Button>
        </div>
        <div className="bb-3 hrem-2p75 pt1">
          <Button
            onClick={() => {
              onDeleteClick();
              setClicked(0);
            }}
            style={{
              background: 'none',
              color: '#a71629',
              fontSize: '14px',
              outline: 'none',
            }}
            variant="tertiary"
            id="map-delete-layer-btn"
          >
            {translate('mapView:editLayerDropdown.deleteLayer')}
          </Button>
        </div>
      </div>
    </>
  );
  return (
    <Tippy
      arrow={false}
      onClickOutside={() => {
        setClicked(2);
      }}
      interactive
      placement="bottom"
      render={(attrs) => content(attrs)}
      trigger="click"
      zIndex={clicked}
    >
      <button
        data-testid="options-meatball"
        className="pl2 pr0 cursor-pointer tooltip-button b-width-0"
        type="button"
      >
        <OptionsMeatball height="24px" width="24px" />
      </button>
    </Tippy>
  );
};

export default EditLayerDropdown;
